export const opacityScaleTokens = {
  primaryBlue: {
    ultraFaint: 'rgba(115, 167, 236, 0.01)',
    nearGhost: 'rgba(115, 167, 236, 0.015)',
    faint: 'rgba(115, 167, 236, 0.03)',
    whisper: 'rgba(115, 167, 236, 0.04)',
    subtle: 'rgba(115, 167, 236, 0.06)',
    light: 'rgba(115, 167, 236, 0.10)',
    subtleLight: 'rgba(115, 167, 236, 0.12)',
    medium: 'rgba(115, 167, 236, 0.15)',
    bold: 'rgba(115, 167, 236, 0.18)',
    notable: 'rgba(115, 167, 236, 0.22)',
    strong: 'rgba(115, 167, 236, 0.25)',
    firm: 'rgba(115, 167, 236, 0.30)',
    moderate: 'rgba(115, 167, 236, 0.35)',
    heavy: 'rgba(115, 167, 236, 0.40)',
    intense: 'rgba(115, 167, 236, 0.50)',
    dense: 'rgba(115, 167, 236, 0.55)',
    veryStrong: 'rgba(115, 167, 236, 0.60)',
    deep: 'rgba(115, 167, 236, 0.80)',
    solid: 'rgba(115, 167, 236, 0.85)',
  },
  purple: {
    ultraFaint: 'rgba(120, 80, 255, 0.01)',
    faint: 'rgba(120, 80, 255, 0.03)',
    subtle: 'rgba(120, 80, 255, 0.06)',
    light: 'rgba(120, 80, 255, 0.10)',
    medium: 'rgba(120, 80, 255, 0.15)',
    strong: 'rgba(120, 80, 255, 0.25)',
    heavy: 'rgba(120, 80, 255, 0.40)',
    veryStrong: 'rgba(120, 80, 255, 0.60)',
  },
  whiteOverlay: {
    transparent: 'rgba(255, 255, 255, 0)',
    ultraFaint: 'rgba(255, 255, 255, 0.01)',
    faint: 'rgba(255, 255, 255, 0.03)',
    whisper: 'rgba(255, 255, 255, 0.04)',
    whisperLight: 'rgba(255, 255, 255, 0.045)',
    subtle: 'rgba(255, 255, 255, 0.05)',
    soft: 'rgba(255, 255, 255, 0.06)',
    light: 'rgba(255, 255, 255, 0.08)',
    airy: 'rgba(255, 255, 255, 0.10)',
    medium: 'rgba(255, 255, 255, 0.12)',
    veil: 'rgba(255, 255, 255, 0.14)',
    notable: 'rgba(255, 255, 255, 0.15)',
    prominent: 'rgba(255, 255, 255, 0.16)',
    bold: 'rgba(255, 255, 255, 0.18)',
    strong: 'rgba(255, 255, 255, 0.20)',
    intense: 'rgba(255, 255, 255, 0.25)',
    heavy: 'rgba(255, 255, 255, 0.35)',
    veryStrong: 'rgba(255, 255, 255, 0.50)',
    dense: 'rgba(255, 255, 255, 0.85)',
    almost: 'rgba(255, 255, 255, 0.92)',
    nearOpaque: 'rgba(255, 255, 255, 0.95)',
    solid: '#ffffff',
  },
  blackOverlay: {
    ultraFaint: 'rgba(0, 0, 0, 0.01)',
    faint: 'rgba(0, 0, 0, 0.03)',
    subtle: 'rgba(0, 0, 0, 0.06)',
    light: 'rgba(0, 0, 0, 0.10)',
    fade: 'rgba(0, 0, 0, 0.12)',
    medium: 'rgba(0, 0, 0, 0.15)',
    mediumStrong: 'rgba(0, 0, 0, 0.20)',
    strong: 'rgba(0, 0, 0, 0.25)',
    firm: 'rgba(0, 0, 0, 0.30)',
    prominent: 'rgba(0, 0, 0, 0.35)',
    heavy: 'rgba(0, 0, 0, 0.40)',
    mediumFirm: 'rgba(0, 0, 0, 0.45)',
    intense: 'rgba(0, 0, 0, 0.50)',
    dim: 'rgba(0, 0, 0, 0.55)',
    veryStrong: 'rgba(0, 0, 0, 0.60)',
    deeper: 'rgba(0, 0, 0, 0.65)',
    deep: 'rgba(0, 0, 0, 0.70)',
    dense: 'rgba(0, 0, 0, 0.85)',
    almost: 'rgba(0, 0, 0, 0.92)',
    nearOpaque: 'rgba(0, 0, 0, 0.95)',
    solid: '#000000',
  },
  successGreen: {
    faint: 'rgba(142, 211, 130, 0.03)',
    medium: 'rgba(142, 211, 130, 0.15)',
    strong: 'rgba(142, 211, 130, 0.25)',
    bold: 'rgba(142, 211, 130, 0.70)',
    veryStrong: 'rgba(142, 211, 130, 0.60)',
    intense: 'rgba(142, 211, 130, 0.80)',
    vivid: 'rgba(142, 211, 130, 0.90)',
    solid: 'rgba(142, 211, 130, 1)',
  },
  warningAmber: {
    faint: 'rgba(208, 163, 66, 0.03)',
    subtle: 'rgba(208, 163, 66, 0.06)',
    moderate: 'rgba(208, 163, 66, 0.20)',
    firm: 'rgba(208, 163, 66, 0.30)',
    bold: 'rgba(208, 163, 66, 0.70)',
    intense: 'rgba(208, 163, 66, 0.85)',
    vivid: 'rgba(208, 163, 66, 0.90)',
    solid: 'rgba(208, 163, 66, 1)',
  },
  errorRed: {
    subtle: 'rgba(216, 98, 94, 0.06)',
    light: 'rgba(216, 98, 94, 0.10)',
    firm: 'rgba(216, 98, 94, 0.30)',
    intense: 'rgba(216, 98, 94, 0.80)',
    deep: 'rgba(216, 98, 94, 0.85)',
    vivid: 'rgba(216, 98, 94, 0.90)',
  },
  violet: {
    moderate: 'rgba(167, 173, 246, 0.20)',
  },
  goldWarm: {
    medium: 'rgba(255, 215, 0, 0.15)',
    strong: 'rgba(255, 215, 0, 0.25)',
    firm: 'rgba(255, 215, 0, 0.30)',
    veryStrong: 'rgba(255, 215, 0, 0.60)',
  },
  // Cyan #77CCE6 alpha family — bright.tradingFloor.cyan* 외 alpha 변형들 (AR holo / scan-line accents).
  // 2026-05-18 promotion (shared/ui phase 2).
  cyan: {
    ultraFaint: 'rgba(119, 204, 230, 0.02)',
    nearTransparent: 'rgba(119, 204, 230, 0.03)',
    whisper: 'rgba(119, 204, 230, 0.04)',
    dust: 'rgba(119, 204, 230, 0.05)',
    faint: 'rgba(119, 204, 230, 0.08)',
    airy: 'rgba(119, 204, 230, 0.10)',
    notable: 'rgba(119, 204, 230, 0.15)',
    strong: 'rgba(119, 204, 230, 0.20)',
    firm: 'rgba(119, 204, 230, 0.30)',
    vivid: 'rgba(119, 204, 230, 0.45)',
    bold: 'rgba(119, 204, 230, 0.50)',
    dense: 'rgba(119, 204, 230, 0.65)',
    deep: 'rgba(119, 204, 230, 0.70)',
  },
  // Sky blue #9CC0F1 alpha family — HoloPane window chrome / 광학 표면 accents (motif-neutral).
  // 2026-05-18 promotion (shared/ui phase 2).
  skyBlue: {
    faint: 'rgba(156, 192, 241, 0.08)',
    airy: 'rgba(156, 192, 241, 0.10)',
    notable: 'rgba(156, 192, 241, 0.15)',
    strong: 'rgba(156, 192, 241, 0.25)',
    firm: 'rgba(156, 192, 241, 0.30)',
    moderate: 'rgba(156, 192, 241, 0.35)',
    heavy: 'rgba(156, 192, 241, 0.40)',
    vivid: 'rgba(156, 192, 241, 0.45)',
    intense: 'rgba(156, 192, 241, 0.50)',
    bold: 'rgba(156, 192, 241, 0.60)',
    prominent: 'rgba(156, 192, 241, 0.65)',
    deep: 'rgba(156, 192, 241, 0.70)',
    dense: 'rgba(156, 192, 241, 0.80)',
    solid: 'rgba(156, 192, 241, 0.85)',
  },
  // Bright green #4ED48A alpha family — scenario success indicators (scenario phase 2, 2026-05-18).
  brightGreen: {
    light: 'rgba(78, 212, 138, 0.10)',
    notable: 'rgba(78, 212, 138, 0.15)',
    moderate: 'rgba(78, 212, 138, 0.20)',
    strong: 'rgba(78, 212, 138, 0.40)',
    bold: 'rgba(78, 212, 138, 0.70)',
    intense: 'rgba(78, 212, 138, 0.85)',
  },
  // Deep panel surface family — scenario detail dashboard / TradingFloorPanel backgrounds.
  // motif-neutral 색이지만 deep/dim 톤이라 별 카테고리. (scenario phase 2, 2026-05-18)
  deepPanel: {
    panel0: '#02030a',
    panel1: '#050507',
    panel2: '#1a1a1d',
    panel3: '#1a1a1e',
    panel4: '#2a2a2e',
    panel5: '#3a3b3f',
    deepRgba: 'rgba(8, 12, 22, 0.95)',
    midRgba: 'rgba(14, 20, 36, 0.85)',
  },
} as const;

export type OpacityScaleTokens = typeof opacityScaleTokens;
